// Event detail page behaviour (EventsExperience.tsx → EventDetail).
//
// Two pieces of the design are interactive: the booking bar that appears once
// the hero has scrolled away, and the programme's day tabs. The FAQ accordion
// is Bootstrap collapse, handled by the accordion block itself.

/** Reveals the sticky booking bar once the element it watches is scrolled past. */
function initStickyBookingBar(bar: HTMLElement) {
  const watchSelector = bar.dataset.stickyAfter;
  const watched = watchSelector ? document.querySelector<HTMLElement>(watchSelector) : null;

  if (!watched) return;

  // The design reveals the bar 80px before the hero fully leaves.
  const reveal = () => {
    const past = window.scrollY > watched.offsetHeight - 80;
    bar.classList.toggle('visible', past);
  };

  window.addEventListener('scroll', reveal, { passive: true });
  window.addEventListener('resize', reveal);
  reveal();
}

/** Day tabs over the programme: one panel visible at a time. */
function initProgrammeTabs(tabs: HTMLElement) {
  const buttons = [...tabs.querySelectorAll<HTMLElement>('[data-programme-day]')];
  const section = tabs.closest('section');

  if (!section || buttons.length === 0) return;

  const panels = [...section.querySelectorAll<HTMLElement>('[data-programme-panel]')];

  const show = (index: string) => {
    buttons.forEach(b => {
      const active = b.dataset.programmeDay === index;
      b.classList.toggle('active', active);
      b.setAttribute('aria-selected', String(active));
    });
    panels.forEach(p => { p.hidden = p.dataset.programmePanel !== index; });
  };

  tabs.addEventListener('click', event => {
    const button = (event.target as HTMLElement).closest<HTMLElement>('[data-programme-day]');
    if (button?.dataset.programmeDay) show(button.dataset.programmeDay);
  });
}

export function initEventDetail() {
  document.querySelectorAll<HTMLElement>('[data-sticky-booking-bar]').forEach(initStickyBookingBar);
  document.querySelectorAll<HTMLElement>('[data-programme-tabs]').forEach(initProgrammeTabs);
}
